import { fonts, standardFontIds } from './constants'
import { Descendant, EditorDraft, FontId } from './types'

export const isStandardFont = (fontId: FontId) => standardFontIds.includes(fontId)
export const fontSupportsBold = (fontId: FontId) => !!fonts[fontId].hasBold
export const fontSupportsItalic = (fontId: FontId) =>
  !!(fonts[fontId].hasOblique || fonts[fontId].hasItalic)
export const isVersion2Draft = (draft: Descendant[] | EditorDraft): draft is EditorDraft =>
  !Array.isArray(draft)
